import { Badge } from "../../Badge";
import Avatar from "../Avatar";
import { badgeWrap } from "./badgeAvatar.css";
import { BadgeAvatarProps } from "./types";

const BadgeAvatar = ({ team, size = "medium" }: BadgeAvatarProps) => (
  <Avatar code={team.code} size={size}>
    <div className={badgeWrap[size]}>
      <Badge team={team} isAlternative />
    </div>
  </Avatar>
);

export default BadgeAvatar;
